import {DataDirection} from '../helpers';

export class SystemInterconnection {
  addressAndInterface: string;
  externalOrgName: string;
  externalPointOfContact: string;
  connectionSecurity: string;
  dataDirection: DataDirection;
  informationBeingTransmitted: string;
  portOrCircuitNumbers: string;
}
